import { useState, FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();

    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    try {
      const res = await fetch('https://readdy.ai/api/form/d9qo5uvnahb7382ovco0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.meta?.detail || parsed?.message || responseText;
        setErrorMsg(serverMsg.includes('spam') ? '提交失败，请稍后再试' : serverMsg || '提交失败，请稍后再试');
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络异常，请稍后再试');
      setStatus('error');
    }
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-accent-500">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center bg-white/20 rounded-2xl">
          <i className="ri-mail-send-line text-2xl md:text-3xl text-background-50"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
          订阅更新通知
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-8 max-w-lg mx-auto">
          订阅后，每周将收到最新福利视频网址更新推送，精彩内容不再错过
        </p>

        {status === 'success' ? (
          <div className="bg-white/15 backdrop-blur-sm rounded-full px-6 py-4 max-w-md mx-auto">
            <p className="text-background-50 text-sm">
              <i className="ri-checkbox-circle-fill mr-2"></i>订阅成功！感谢您的关注
            </p>
          </div>
        ) : (
          <form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
            data-readdy-form=""
            id="newsletter-form"
            onSubmit={handleSubmit}
          >
            <input
              type="email"
              name="email"
              placeholder="请输入您的邮箱地址"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-5 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-background-50 placeholder:text-background-50/50 text-sm focus:outline-none focus:border-white/40 transition-colors"
            />
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="honeypot-field"
            />
            <button
              type="submit"
              className="w-full sm:w-auto px-7 py-3 bg-background-50 text-accent-600 rounded-full font-semibold text-sm whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
            >
              立即订阅
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-background-50/80 text-xs mt-3">{errorMsg}</p>
        )}
        <p className="text-background-50/50 text-xs mt-4">
          我们尊重您的隐私，不会发送垃圾邮件
        </p>
      </div>
    </section>
  );
}